import {
  Component, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit
} from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Router } from '@angular/router';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  standalone: false
})
export class MapComponent implements OnChanges, AfterViewInit {
  @Input() propiedades: any[] = [];

  @ViewChild(GoogleMap, { static: false }) mapComponent!: GoogleMap;

  zoom = 13;
  center: google.maps.LatLngLiteral = { lat: -33.335, lng: -60.217 };

  private clusterer?: MarkerClusterer;

  constructor(private router: Router) {}

  ngAfterViewInit(): void {
    this.rebuildMarkers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['propiedades'] && this.mapComponent?.googleMap) {
      this.rebuildMarkers();
    }
  }

  private rebuildMarkers(): void {
    if (!this.mapComponent?.googleMap) return;

    const items = (this.propiedades ?? [])
      .filter(p => p?.domicilio && p.domicilio.lat != null && p.domicilio.lng != null);

    const markers = items.map(p => {
      // 👇 Determinar ícono según operación
      // const iconUrl = p.tipoOperacion.code === 'VENTA'
      //   ? '/assets/icons/venta.png'
      //   : '/assets/icons/alquila.png';
      const iconUrl = '/assets/icons/mark.png';
      const marker = new google.maps.Marker({
        position: {
          lat: Number(p.domicilio.lat),
          lng: Number(p.domicilio.lng)
        },
        title: `${p.domicilio.calle} ${p.domicilio.numero ?? ''}`,
        icon: {
          url: iconUrl,   // 👈 logo o cartel
          scaledSize: new google.maps.Size(40, 40), // ajustar tamaño
        }
      });

      // 👇 Click → ir al detalle
      marker.addListener("click", () => {
        this.router.navigate(['/propiedad', p.id]);
      });

      return marker;
    });

    if (markers.length) {
      this.center = markers[0].getPosition()!.toJSON();
    }

    // limpiar cluster anterior
    if (this.clusterer) {
      this.clusterer.clearMarkers();
    }

    // crear cluster
    this.clusterer = new MarkerClusterer({
      map: this.mapComponent.googleMap!,
      markers,
    });
  }
}
